module.exports = __webpack_public_path__ + "static/media/fa-brands-400.0d215870.woff";